import { compose, filter, isEmpty, keys, length, map, not, path, pathOr, propEq } from 'ramda'

export default {
  /**
   * Returns an array of the offer line IDs that are currently marked as busy.
   *
   * @param {Object} state
   * @return {Array}
   */
  busyOfferLineIds: compose(map(Number), keys, path(['busyOfferLineIds'])),

  /**
   * Does the user have a current, populated basket?
   *
   * @param {Object} state
   * @return {boolean}
   */
  hasPopulatedBasket: compose(not, isEmpty, pathOr([], ['currentBasket', 'offers'])),

  /**
   * Gets the lines from the current basket.
   *
   * @param {Object} state
   * @return {Array}
   */
  currentBasketLines: pathOr([], ['currentBasket', 'basketLines']),

  /**
   * Gets the lines from the current basket.
   *
   * @param {Object} state
   * @return {Array}
   */
  currentBasketCurrencyCode: pathOr(null, ['currentBasket', 'currencyCode']),

  /**
   * Identifies whether the basket has any lines with a quantity of 0.
   *
   * @param {Object} state
   * @return {Boolean}
   */
  basketHasZeroQuantityLine: compose(
    Boolean,
    length,
    filter(propEq('unitQuantity', 0)),
    pathOr([], ['currentBasket', 'basketLines']),
  ),
}
